/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Metric_UptimeInputs */

const en_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime mindset`)
};

const ar_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقلية الاستقرار`)
};

const bn_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপটাইমের রেকর্ড`)
};

const de_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime-Denkweise`)
};

const es_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentalidad de disponibilidad`)
};

const fr_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`État d'esprit de disponibilité`)
};

const pt_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentalidade de tempo de atividade`)
};

const zh_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正常运行时间心态`)
};

const tr_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışma süresi zihniyeti`)
};

const ru_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мышление о времени безотказной работы`)
};

const pl_cta_metric_uptime = /** @type {(inputs: Cta_Metric_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastawienie na czas sprawności`)
};

/**
* | output |
* | --- |
* | "Uptime mindset" |
*
* @param {Cta_Metric_UptimeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_metric_uptime = /** @type {((inputs?: Cta_Metric_UptimeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Metric_UptimeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_metric_uptime(inputs)
	if (locale === "bn") return bn_cta_metric_uptime(inputs)
	if (locale === "de") return de_cta_metric_uptime(inputs)
	if (locale === "es") return es_cta_metric_uptime(inputs)
	if (locale === "fr") return fr_cta_metric_uptime(inputs)
	if (locale === "pt") return pt_cta_metric_uptime(inputs)
	if (locale === "zh") return zh_cta_metric_uptime(inputs)
	if (locale === "tr") return tr_cta_metric_uptime(inputs)
	if (locale === "ru") return ru_cta_metric_uptime(inputs)
	if (locale === "pl") return pl_cta_metric_uptime(inputs)
	return en_cta_metric_uptime(inputs)
});